// FontPreviewStep.tsx — step 'font-preview' del onboarding.
// Qué hace: lista las fuentes detectadas en el sitio y deja elegir una (o saltar).
// Qué exporta: FontPreviewStep.
// Quién lo usa: CreateWorkspaceModal.

import { Button } from '../../Button';
import { FontPreviewList, FontPreviewItem, FontName, FontSample } from '../styled';

interface Props {
  fonts: string[];
  selectedFont: string | null;
  setSelectedFont: React.Dispatch<React.SetStateAction<string | null>>;
  confirmFont: () => void;
}

export function FontPreviewStep({ fonts, selectedFont, setSelectedFont, confirmFont }: Props) {
  return (
    <>
      <FontPreviewList>
        {fonts.map(font => (
          <FontPreviewItem
            key={font}
            $selected={selectedFont === font}
            onClick={() => setSelectedFont(prev => prev === font ? null : font)}
          >
            <FontName>{font}</FontName>
            <FontSample style={{ fontFamily: font }}>
              The quick brown fox jumps over the lazy dog
            </FontSample>
          </FontPreviewItem>
        ))}
      </FontPreviewList>
      <Button type="button" onClick={confirmFont} style={{ width: '100%' }}>
        {selectedFont ? `Use ${selectedFont}` : 'Skip — use defaults'}
      </Button>
    </>
  );
}
